import { Dispatch, SetStateAction } from "react";
import Dropzone from "react-dropzone";
import UploadIcon from "~icons/local/upload";
import ClearIcon from "~icons/fa6-solid/x";
import FileIcon from "~icons/fa6-regular/file";

export default function AttachFiles({
  files,
  setFiles,
  disabled = false,
}: {
  files: File[];
  setFiles: Dispatch<SetStateAction<File[]>>;
  disabled?: boolean;
}) {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        {files.map(({ name }) => (
          <div
            key={name}
            className="text-xs bg-blue-50 rounded-md px-4 py-2 flex justify-between items-center"
          >
            <div className="flex items-center gap-2">
              <FileIcon className="text-slate-400 size-3" />
              <div>{name}</div>
            </div>
            <ClearIcon
              className="cursor-pointer text-slate-400 hover:text-slate-600 size-3"
              onClick={() => setFiles(files.filter((f) => f.name !== name))}
            />
          </div>
        ))}
      </div>
      {!disabled && (
        <Dropzone
          onDrop={(acceptedFiles) => setFiles([...files, ...acceptedFiles])}
          accept={{
            "image/*": [".png", ".gif", ".jpeg", ".jpg"],
            "application/pdf": [".pdf"],
            "application/STEP": [".step", ".stp"],
          }}
          maxSize={10e6}
        >
          {({ getRootProps, getInputProps }) => (
            <div
              {...getRootProps()}
              className="flex flex-col gap-4 items-center cursor-pointer border rounded-md p-6"
            >
              <input {...getInputProps()} />
              <UploadIcon />
              <div className="text-sm text-slate-500 text-center">
                Click to upload or drag and drop PDF, STEP, PNG, JPG or GIF
              </div>
            </div>
          )}
        </Dropzone>
      )}
    </div>
  );
}
